import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { spartanburgConfig } from "./data";

export default function SpartanburgPage() {
  return <CityPageTemplate config={spartanburgConfig} />;
}